export const VaultStrategy = ({ strategy }: { strategy: string }) => {
	return (
		<div className="flex flex-col gap-lg">
			<span className="typo-label-sm text-text-default">Strategy</span>
			<span className="typo-body-xs text-text-secondary">{strategy}</span>
		</div>
	);
};
